import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(CenteredFlexColumn)<{ isDisabled: boolean }>`
    padding: 8px 8px 4px 8px;
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.blue[100]};
    background: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon[50] : colorsPalettes.blue[50])};
    max-width: 184px;
    box-sizing: border-box;
    overflow: hidden;
`;

export const InnerCard = styled(CenteredFlexColumn)`
    background: ${colorsPalettes.carbon[0]};
    padding: 12px;
    border-radius: 3px;
    gap: 4px;
    text-align: center;
    width: 168px;
    height: 136px;
    box-sizing: border-box;
`;

export const UnclaimedTitle = styled.div`
    ${setFontVariant("body2", colorsPalettes.midnight[300])};
    padding: 0 8px;
    background: ${colorsPalettes.blue[100]};
    border-radius: 6px;
`;

export const ClaimedTitle = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
`;

export const DisabledTitle = styled.div`
    ${setFontVariant("h2", colorsPalettes.carbon[300])};
`;

export const TitleBold = styled.span`
    ${setFontVariant("input2Bold", colorsPalettes.midnight[300])};
`;

export const SubTitle = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[400])};
    white-space: pre-line;
`;

export const DisabledSubTitle = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
`;

export const Link = styled.span`
    ${setFontVariant("caption", colorsPalettes.blue[400])};
    text-decoration: underline;
    cursor: pointer;
`;

export const Percent = styled.div`
    ${setFontVariant("h2", colorsPalettes.blue[400])};
`;

export const ToUnlock = styled.div`
    ${setFontVariant("button", colorsPalettes.carbon[200])};
    padding: 8px 16px;
    height: 20px;
`;
